import * as React from 'react';
import { History } from 'history';
import Model from './personalinfotype-model';
import BaseList from '../base/base-list.component';

interface IProps {  
  history: History;
  root?: string;
  caption?: string;
  personalinfotypeType?: string;
  actions?: any;
  disableBackButton?: boolean;
  disableCard?: boolean;
}

interface IState {
}

export default class PersonalinfotypeList extends React.Component<IProps, IState> {
  public render(): React.ReactNode {
    return (
      <BaseList history={this.props.history} caption={this.props.caption} endPointFilter={Model.endPointFilterList(this.props.personalinfotypeType)} url={(this.props.root || '') + (this.props.personalinfotypeType? '/' + this.props.personalinfotypeType+ 'type' : Model.url)} model={Model} actions={this.props.actions} disableBackButton={this.props.disableBackButton} disableCard={this.props.disableCard}/>
    );
  }
}
